define(['jquery', 'jquery.transit', 'modernizr', 'container', 'module-media-slider', 'load-more', 'jump', 'underscore'],
    function ($, transit, modernizr, container, moduleMediaSlider, loadMoreFactory, jumpFactory, _) {

        return (function () {

            const name = 'game';

            const model = container.getBaseModel(name);
            const view = container.getBaseView(name);
            const loadMore = loadMoreFactory.create();
            const jump = jumpFactory.create();
            const pubSub = container.getPublishSubscribe();
            /* model */

            model.publicVars = {};

            model.privateVars = {};

            model.methods = {
                getSortItems: function (type) {

                    let tags = '';

                    if(view.privateVars.currentItemTags.length > 0) {
                        tags = '/' + view.privateVars.currentItemTags.join(',');
                    }

                    const url = model.publicVars.ajaxSortEndpoint + tags;

                    $.ajax({
                        url: url,
                        type: 'GET',
                        data: {}
                    }).done(function (data) {
                        pubSub.publish('view/actionShowSortItems', data);
                    });
                },
            };

            /* view */

            view.publicVars = {};

            view.privateVars = {
                itemsKeys: [],
                items: new Map(),
                canNavigateAction: 0,
                currentItemTags: [],
                sortingFlag: false
            };

            view.startup = function () {

                if(view.publicVars.moduleMediaSliderConfig) {
                    view.privateVars.itemsKeys.push('media-slider');

                    view.privateVars.items.set('media-slider', {
                        init: false,
                        module: moduleMediaSlider,
                        config: view.publicVars.moduleMediaSliderConfig,
                        callbacks: {}
                    });
                }

                view.methods.handleCurrentScrollPosition();

                if($(view.publicVars.cssId.loadMoreWrapperId).length > 0) {
                    loadMore.init(view.publicVars.loadMoreSetup);
                    loadMore.setAdditionalParamCallback(view.methods.getCurrentTags);
                }

                // moduleMediaCarousel.init(view.publicVars.moduleMediaCarouselConfig);
                // moduleVideoCarousel.init(view.publicVars.moduleVideoCarouselConfig);

            };

            view.bind = function () {
                $(window).scroll(function () {

                    let ticking = false;

                    if (view.privateVars.canNavigateAction === 0) {

                        if (!ticking) {
                            window.requestAnimationFrame(function () {
                                view.methods.handleCurrentScrollPosition();
                                ticking = false;
                            });
                        }
                        ticking = true;
                    }
                });

                $(window).resize(() => {
                    view.methods.handleCurrentScrollPosition();
                });

                $(window).on('orientationchange', () => {
                    view.methods.handleCurrentScrollPosition();
                });

                $(view.publicVars.cssId.gameSortSmallButtonCls).click(function () {
                    const type = container.getData($(this)[0], 'type');

                    if(!view.privateVars.sortingFlag) {
                        view.privateVars.sortingFlag = true;
                        view.methods.sortItems(type);
                    }
                });
            };

            view.methods = {

                sortItems: (type) => {
                    loadMore.disable();

                    if(view.privateVars.currentItemTags.includes(type)) {
                        $(view.publicVars.cssId.gameSortSmallButtonCls + '-' + type).removeClass(view.publicVars.cssId.isActiveCls.substr(1));
                        view.privateVars.currentItemTags = view.privateVars.currentItemTags.filter(function (item) {
                            return item !== type;
                        });
                    } else {
                        $(view.publicVars.cssId.gameSortSmallButtonCls + '-' + type).addClass(view.publicVars.cssId.isActiveCls.substr(1));
                        view.privateVars.currentItemTags.push(type);
                    }

                    const oldHeight = $(view.publicVars.cssId.gameInfoBoxesWrapperCls).outerHeight();
                    const loadMoreWrapperHeight = $(view.publicVars.cssId.loadMoreWrapperId).outerHeight();
                    const headerHeight = $(view.publicVars.cssId.headerCls).outerHeight();
                    const newWindowHeight = $(window).height() - headerHeight;
                    let newHeight = oldHeight + loadMoreWrapperHeight;

                    if(newHeight > newWindowHeight) {
                        newHeight = newWindowHeight;
                    }

                    $(view.publicVars.cssId.itemCls).transit({opacity: 0}, 300, function () {});

                    $(view.publicVars.cssId.gameInfoBoxesWrapperCls).css({ height: newHeight + 'px'});
                    $(view.publicVars.cssId.loadMoreWrapperId).css({display: 'none'});

                    $(view.publicVars.cssId.gameInfoBoxesWrapperCls).css({ overflow: 'hidden'});

                    $(view.publicVars.cssId.gameInfoBoxesWrapperCls).transit({ height: newHeight + 'px'}, 300, function () {
                        $(view.publicVars.cssId.wrapperCls).html('');

                        $(view.publicVars.cssId.gameInfoBoxesWrapperCls).addClass(view.publicVars.cssId.isSortingCls.substr(1));

                        $(view.publicVars.cssId.gameInfoBoxSortLoaderId).css({display: 'block' });
                        $(view.publicVars.cssId.gameInfoBoxSortLoaderId).transit({opacity: 1});
                        jump.centerTo(view.publicVars.cssId.gameInfoBoxSortLoaderId, () => {
                            model.methods.getSortItems(type);
                        }, {
                            modifier: - parseInt(headerHeight)
                        });
                    });

                },

                actionShowSortItems: (action, data) => {
                    const compiled = _.template($(view.publicVars.cssId.templateId).html());

                    const output = compiled({
                        data: data
                    });

                    $(view.publicVars.cssId.wrapperCls).html(output);

                    $(view.publicVars.cssId.gameInfoBoxesWrapperCls).removeAttr('style');

                    $(view.publicVars.cssId.itemCls + view.publicVars.cssId.isAddedCls).removeClass(view.publicVars.cssId.isAddedCls.substr(1));

                    $(view.publicVars.cssId.loadMoreWrapperId).removeAttr('style');

                    $(view.publicVars.cssId.gameInfoBoxesWrapperCls).removeClass(view.publicVars.cssId.isSortingCls.substr(1));

                    $(view.publicVars.cssId.gameInfoBoxSortLoaderId).removeAttr('style');

                    loadMore.enable(data);

                    view.privateVars.sortingFlag = false;
                },

                handleCurrentScrollPosition: () => {

                    const systemCurrentScroll = $(document).scrollTop();

                    for (let [key, value] of view.privateVars.items) {

                        const targetPos = $(view.publicVars.cssId.layout.navigateTargetId + '-' + key).offset();

                        view.methods.handleModuleInit(systemCurrentScroll, key, targetPos);
                    }
                },

                getCurrentTags: () => {
                    return view.privateVars.currentItemTags.join(',');
                },

                handleModuleInit: (currentScroll, key, targetPos) => {

                    if (view.privateVars.items.get(key).module && view.privateVars.items.get(key).init === false) {
                        const rect = $(view.publicVars.cssId.layout.navigateTargetId + '-' + key)[0].getBoundingClientRect();
                        const scrollPlusWindowHeight = $(window).height() + currentScroll;

                        if ((targetPos.top - 200) < scrollPlusWindowHeight &&
                            (scrollPlusWindowHeight < (targetPos.top + rect.height) || currentScroll < (targetPos.top + rect.height))) {

                            view.methods.fireModuleStart(key);

                        }
                    }

                },

                fireModuleStart: (key) => {
                    if (view.privateVars.items.get(key).module && view.privateVars.items.get(key).init === false) {

                        view.privateVars.items.get(key).init = true;
                        view.privateVars.items.get(key).module.init(
                            view.privateVars.items.get(key).config,
                            view.privateVars.items.get(key).callbacks
                        );
                    }
                }
            };

            /* custom events */
            pubSub.subscribe('view/actionShowSortItems', view.methods.actionShowSortItems);
            //pubSub.subscribe('view/actionShowFormThx', view.methods.actionShowFormThx);
            //pubSub.subscribe('view/showThx', view.methods.showThx);


            /* public methods */
            return {
                init: function (options) {
                    model.init(options);
                    view.init(options);
                }
            };


        })();


    });
